import { render, staticRenderFns } from "./IconSend.vue?vue&type=template&id=9d9b9c64&"
import script from "./IconSend.vue?vue&type=script&lang=js&"
export * from "./IconSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d9b9c64')) {
      api.createRecord('9d9b9c64', component.options)
    } else {
      api.reload('9d9b9c64', component.options)
    }
    module.hot.accept("./IconSend.vue?vue&type=template&id=9d9b9c64&", function () {
      api.rerender('9d9b9c64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSend.vue"
export default component.exports